import { Badge, type BadgeProps } from '@/components/ui/Badge'
import type { MailboxConnectionState } from '@/types/admin'

const states: Record<MailboxConnectionState, { label: string; tone: BadgeProps['tone'] }> = {
  ok: { label: 'Connected', tone: 'success' },
  failing: { label: 'Not answering', tone: 'danger' },
  untested: { label: 'Not tried yet', tone: 'warning' },
  unconfigured: { label: 'Not configured', tone: 'neutral' },
}

export function ConnectionState({ state }: { state: MailboxConnectionState }) {
  const s = states[state] ?? states.unconfigured
  return <Badge tone={s.tone} size="md" dot>{s.label}</Badge>
}

/** Absolute, never relative: the initiator only runs office hours, so "3 days ago" is not a fault. */
export function formatTimestamp(value: string | null) {
  if (!value) return '-'
  return new Date(value).toLocaleString('sv-SE', { dateStyle: 'short', timeStyle: 'short' })
}
